import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  padding: 45px 20px;
  flex-grow: 1;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: inline-block;
`;

export const Icon = styled.img`
  display: block;
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
`;

export const Text = styled.div`
  font-size: 22px;
  line-height: 1.2;
  font-weight: 400;
`;
